<template>
  <div>
    <Form @submit.native.prevent="preventSubmit" inline>
      <FormItem prop="keyword" label="查询：" :label-width="84">
        <Input type="text" v-model="keyword" placeholder="查询关键字"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="queryWithCondition">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="openEditActivityModal">新增活动</Button>
      </FormItem>
    </Form>
    <Table stripe :loading="loading" height="650" :columns="columns" :data="data" style="margin-left: 2px;"></Table>
    <div style="margin: 10px;overflow: hidden">
      <Page show-sizer placement="top" :total="count" :current="page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>

    <Modal v-model="editActivityModal.display" ref="editActivityModal" :loading="true" :width="1000" :title="editActivityModal.title" @on-ok="preEditActivity" ok-text="提交内容" cancel-text="关闭">
      <Form @submit.native.prevent="preventSubmit" ref="editActivityModalForm" :model="editActivityModal" :rules="editActivityModal.rules" :label-width="150">
        <FormItem label="活动名称：" prop="name">
          <Input type="text" v-model="editActivityModal.name"></Input>
        </FormItem>
        <FormItem  label="活动价格比例(%)：" prop="percentage">
          <InputNumber v-model="editActivityModal.percentage" :min="1" :max="100"></InputNumber>
        </FormItem>
        <FormItem  label="下单时间：" prop="placeDate">
          <DatePicker v-model="editActivityModal.placeDate" @on-change="dateRange => {changeDate(dateRange, 'editActivityModal', 'placeDate')}" format="yyyy-MM-dd HH:mm" type="datetimerange" placeholder="选择日期" style="width: 100%" :options="dateOptions" :clearable="false" :editable="false" transfer></DatePicker>
        </FormItem>
        <FormItem  label="入住时间：" prop="checkDate">
          <DatePicker v-model="editActivityModal.checkDate" @on-change="dateRange => {changeDate(dateRange, 'editActivityModal', 'checkDate')}" format="yyyy-MM-dd HH:mm" type="datetimerange" placeholder="选择日期" style="width: 100%" :options="dateOptions" :clearable="false" :editable="false" transfer></DatePicker>
        </FormItem>
        <FormItem prop="remark" label="备注：">
          <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" v-model="editActivityModal.remark" placeholder="必填"></Input>
        </FormItem>
        <FormItem prop="type" label="活动模式：">
          <Select v-model="editActivityModal.type" transfer clearable filterable>
            <Option :value="1">全天型</Option>
            <Option :value="2">时段型</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import Utils from "@/utils";
import Moment from "moment";

export default {
  name: 'roomTypeList',
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.hotelId = Utils.getUrlParameterByName("hotelId");
  },
  props: {
    query: {
      type: Function,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dateOptions: {
        disabledDate (date) {
          let oneDay = 86400000; // 一天时间（毫秒）

          return date && date.valueOf() < Date.now() - oneDay;
        }
      },
      columns: [
        {
          title: "ID",
          key: "id",
          align: "center",
          width: 150,
        },
        {
          title: "活动名称",
          key: "roomTypeName",
          align: "center",
          width: 150
        },
        {
          title: "活动模式",
          key: "city",
          align: "center",
          width: 100
        },
        {
          title: "活动价格比率(%)",
          key: "city",
          align: "center",
          width: 300
        },
        {
          title: "活动详情",
          key: "packageRoomCount",
          align: "center",
          width: 200
        },
        {
          title: "下单开始时间",
          key: "bufferCount",
          align: "center",
          width: 200
        },
        {
          title: "下单结束时间",
          key: "bufferCount",
          align: "center",
          width: 200
        },
        {
          title: "入住开始时间",
          key: "bufferCount",
          align: "center",
          width: 200
        },
        {
          title: "入住结束时间",
          key: "bufferCount",
          align: "center",
          width: 200
        },
        {
          title: "创建时间",
          key: "bufferCount",
          align: "center",
          width: 200
        },
        {
          title: "创建人",
          key: "bufferCount",
          align: "center",
          width: 200
        },
        {
          title: "最后修改时间",
          key: "bufferCount",
          align: "center",
          width: 200
        },
        {
          title: "最后修改人",
          key: "bufferCount",
          align: "center",
          width: 200
        },
        {
          title: "状态",
          key: "bufferCount",
          align: "center",
          width: 200
        },
        {
          title: "操作",
          align: "center",
          width: 240,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      console.info(params);
                    }
                  }
                },
                "修改活动"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      this.cancelActivity(params.row);
                      console.info(params);
                    }
                  }
                },
                "取消活动"
              )
            ]);
          }
        }
      ],
      page: 1,
      pageSize: 10,
      keyword: '',
      data: [], // 列表数据
      count: 0, // 列表总数
      editActivityModal: {
        display: false,
        title: '新增渠道门店信息',
        name: '',
        percentage: 1,
        placeDate: [
          Moment().format("YYYY-MM-DD HH:mm"),
          Moment().add(7, 'days').format("YYYY-MM-DD HH:mm"),
        ],
        checkDate: [
          Moment().format("YYYY-MM-DD HH:mm"),
          Moment().add(7, 'days').format("YYYY-MM-DD HH:mm"),
        ],
        remark: '',
        type: 1,
        rules: {
          name: [
            { required: true, message: "房型名称不能为空", trigger: "blur" }
          ],
          remark: [
            { required: true, message: "备注不能为空", trigger: "blur" },
            { type: 'string', max: 255, message: "备注不能超过255字" }
          ]
        }
      }
    }
  },
  methods: {
    // 格式化日期
    changeDate(dateRange, formName, datePicker) {
      if (!dateRange[0]) {
        this[formName][datePicker] = [];
      } else {
        if (dateRange[0]==dateRange[1]) {
          dateRange[1] = Moment(dateRange[1]).add(1, 'day')
        }
        let tranferDate = [
          Moment(dateRange[0]).format('YYYY-MM-DD HH:mm'),
          Moment(dateRange[1]).format('YYYY-MM-DD HH:mm')
        ]
        this[formName][datePicker] = tranferDate;
      }
      this.initSelectedRooms();
    },
    queryWithCondition() {

    },
    queryList() {

    },
    openEditActivityModal(payload={}) {
      this.initEditActivityModal(payload);

      this.editActivityModal.display = true;
    },
    // 初始化活动modal
    initEditActivityModal(payload) {
      this.editActivityModal = Object.assign({}, this.editActivityModal, {
        title: '新增渠道门店信息',
        name: '',
        percentage: 1,
        placeDate: [
          Moment().format("YYYY-MM-DD HH:mm"),
          Moment().add(7, 'days').format("YYYY-MM-DD HH:mm"),
        ],
        checkDate: [
          Moment().format("YYYY-MM-DD HH:mm"),
          Moment().add(7, 'days').format("YYYY-MM-DD HH:mm"),
        ],
        remark: '',
        type: 1,
      }, payload)
    },
    // 新增 / 编辑 活动
    preEditActivity() {
      let validResult = true;
      this.$refs.editActivityModalForm.validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        this.$refs.editActivityModal.buttonLoading = false;
        return;
      }

      this.$emit('onConfirm', { name: this.editActivityModal.name, bufferNum: this.editActivityModal.bufferNum });

    },
    // 取消活动
    cancelActivity(activity) {
      this.$Modal.confirm({
        title: "提示",
        content: `确定取消  吗？\n一经确定将无法修改`,
        okText: "确定取消",
        cancelText: "关闭",
        onOk: () => {
          console.info(activity);
        }
      });
    },
    changePage(pageIndex) {
      this.page = pageIndex;
      this.queryList();
    },
    changePageSize(pageSize) {
      this.page = 1;
      this.pageSize = pageSize;
      this.queryList();
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/ota/tujia/hotel-detail/channel-activity-list.vue